(() => {
  const script = document.currentScript;
  const start = () => {
    const source = document.getElementById(script.dataset.accessoryData);
    if (!source || source.dataset.ready) return;
    source.dataset.ready = 'true';
    const products = JSON.parse(source.textContent).filter(p => p.id);
    const panelFor = p => document.querySelector(`[id^="shopify-section-"][id$="__${p.target}"]`);
    const items = products.filter(p => panelFor(p));
    if (!items.length) return;
    let active = items.find(p => p.size === '21' && p.available) || items.find(p => p.available) || items[0];
    let timer;
    const comparison = document.getElementById(script.dataset.accessoryCompare);
    if (comparison) comparison.addEventListener('click', event => {
      if (event.target !== comparison) return;
      const rect = comparison.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) comparison.close();
    });
    const review = document.querySelector('[data-accessory-reviews]');
    const updateReviews = p => {
      if (!review) return;
      const old = review.querySelector('#stamped-main-widget');
      if (old && old.dataset.productId === String(p.id)) return;
      const widget = document.createElement('div');
      widget.id = 'stamped-main-widget';
      Object.entries({'product-id':p.id,name:p.name,'product-title':p.name,url:new URL(p.url,location.origin).href,'image-url':p.image,'product-sku':p.sku || '',description:''}).forEach(([k,v]) => widget.setAttribute(`data-${k}`,v));
      review.replaceChildren(widget);
      clearTimeout(timer);
      let attempts = 0;
      const reload = () => {
        if (typeof StampedFn !== 'undefined' && typeof StampedFn.reloadUGC === 'function') StampedFn.reloadUGC();
        else if (++attempts < 30) timer = setTimeout(reload, 500);
      };
      timer = setTimeout(reload, 150);
    };
    const show = (next, focusAxis) => {
      active = next;
      items.forEach(p => {
        const panel = panelFor(p);
        const selected = p.target === active.target;
        panel.style.display = selected ? 'block' : 'none';
        panel.setAttribute('aria-hidden', String(!selected));
        panel.querySelectorAll('[data-accessory-size]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.accessorySize === active.size)));
        panel.querySelectorAll('[data-accessory-kind]').forEach(b => {
          const match = items.find(x => x.size === p.size && x.kind === b.dataset.accessoryKind);
          b.hidden = !match;
          b.setAttribute('aria-pressed',String(b.dataset.accessoryKind === active.kind));
          b.textContent = b.dataset.accessoryKind + (match && !match.available ? ' — Sold out' : '');
        });
      });
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
        if (focusAxis) panelFor(active).querySelector(`[data-accessory-${focusAxis}][aria-pressed="true"]`)?.focus({preventScroll:true});
      });
      updateReviews(active);
    };
    items.forEach(p => {
      const controls = panelFor(p).querySelector('[data-accessory-options]');
      if (!controls) return;
      [['size','Saw size',['15','21','24']],['kind',script.dataset.optionLabel,[...new Set(items.map(x=>x.kind))]]].forEach(([axis,label,values]) => {
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend'); legend.textContent = label; fieldset.append(legend);
        if (axis === 'kind') {
          if (comparison) {
            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'agawa-comparison-trigger';
            trigger.textContent = comparison.dataset.label || 'Compare options';
            trigger.setAttribute('aria-haspopup', 'dialog');
            trigger.setAttribute('aria-controls', comparison.id);
            trigger.addEventListener('click', () => comparison.showModal());
            legend.append(trigger);
          }
        }
        const row = document.createElement('div'); row.className = 'agawa-accessory-options__buttons';
        values.forEach(value => {
          const button = document.createElement('button'); button.type = 'button';
          button.dataset[axis === 'size' ? 'accessorySize' : 'accessoryKind'] = value;
          button.textContent = axis === 'size' ? `${value} IN` : value;
          button.disabled = axis === 'size' && !items.some(x => x.size === value);
          button.addEventListener('click', () => {
            const next = axis === 'size'
              ? items.find(x => x.size === value && x.kind === active.kind) || items.find(x => x.size === value && x.available) || items.find(x => x.size === value)
              : items.find(x => x.size === active.size && x.kind === value);
            if (next) show(next,axis);
          });
          row.append(button);
        });
        fieldset.append(row); controls.append(fieldset);
      });
    });
    show(active);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
